/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import * as React from "react";

import { isAuthenticated } from "@ef/backend-core";
import { useUserState } from "@ef/feature-user";

import TimeoutMessageComponent, { TimeoutMessageComponentProps } from "./component";

export type TimeoutMessageProps = Omit<TimeoutMessageComponentProps, "user">

/**
 * Displays a message to warn before logout
 */
export default function TimeoutMessage(props: TimeoutMessageProps) { 
    const user = useUserState();

    if (isAuthenticated(user)) {
        return <TimeoutMessageComponent user={user} {...props} />;
    } else {
        return null;
    }
}
